import { EGDSSpacing } from '@egds/react-core/spacing';
import * as React from 'react';
import { Experiment, ExperimentControl, ExperimentVariant } from '@shared-ui/experiment-context';
import { PropertyImportantInfo, PropertyImportantInfoSplitted } from '@shared-ui/lodging-property-details';
import { withSharedUiPropertyDetails } from './shared-ui-property-details';
import { SimpleLazyLoadWrapper } from 'src/common/components/common/lazy/simple-lazy-load-wrapper';
import { usePropertyDetailsQueryCSRExperiment } from './use-property-details-query';
const ImportantInfoWrapper = ({
  inputs
}) => {
  const cSRPropertyDetailsQuery = usePropertyDetailsQueryCSRExperiment();
  return React.createElement(Experiment, {
    name: "Dated_PDP_Split_ProductDetailsQuery"
  }, React.createElement(ExperimentControl, null, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyImportantInfo, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))), React.createElement(ExperimentVariant, {
    bucket: 1
  }, React.createElement(EGDSSpacing, {
    margin: {
      block: 'six'
    }
  }, React.createElement(SimpleLazyLoadWrapper, null, React.createElement(PropertyImportantInfoSplitted, {
    inputs: inputs,
    skipSsr: cSRPropertyDetailsQuery
  })))));
};
export const SharedUiImportantInfoWrapper = withSharedUiPropertyDetails(ImportantInfoWrapper);
SharedUiImportantInfoWrapper.displayName = 'SharedUiImportantInfoWrapper';